<script>

    import { toast } from 'bulma-toast'
    import BucketService from '../$services/bucket.service'

    import File from './file.svelte'

    export let fileDir = null

    export let label = null
    export let accept = null
    export let required = true
    export let loading = false

    export let url = null

    let file = null

    async function uploadFile() {

        const data = await getSigned()

        if(!data)
            return

        loading = true
        const resp = await BucketService.uploadFile(data.signed, file)
        loading = false

        url = data.url
    }

    async function getSigned() {

        const data = {
            fileDir,
            fileType: file.type
        }

        loading = true
        const resp = await BucketService.getSigned(data)
        loading = false

        if(!resp.success) {
            toast({message: resp.error.message, type: 'is-danger'})
            return null
        }

        return resp.data
    }

</script>

<File on:change={ uploadFile } bind:file={ file } { label } { accept } { required } {loading} />